import type React from 'react';
import { forwardRef } from 'react';

export interface EditToolBoxProps {
  children?: React.ReactNode;
}

export const EditToolBox = forwardRef<HTMLDivElement, EditToolBoxProps>(
  ({ children }, ref) => {
    return (
      <div
        className="w-full py-2.5 bg-ds-accent3-100 box-border"
        ref={ref}
      >
        {children}
      </div>
    );
  }
);
